import { createContext, useContext } from 'react';

type ApplicationContextType = {
  applicationId: string;
  // Referring member from the landing URL (`?aid=`), with the `?src=` marker
  // saying which kind of id it is. Null when the visit carried no referral.
  referrerId: string | null;
  referrerIdType: string | null;
};

export const ApplicationContext = createContext<
  ApplicationContextType | undefined
>(undefined);

export function useApplicationContext() {
  const context = useContext(ApplicationContext);
  if (context === undefined) {
    throw new Error(
      'useApplicationContext must be used within an ApplicationContextProvider'
    );
  }
  return context;
}
